/*** IMPORTS FROM imports-loader ***/
var define = false;

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function parallax() {
  gsap.to(".homeHero__copy", {
    yPercent: 100,
    ease: "none",
    scrollTrigger: {
      // trigger: ".homeHero",
      // start: "top bottom", // the default values
      // end: "bottom top",
      scrub: true,
      invalidateOnRefresh: true
    },
  });

  const topLeftTL = gsap.timeline({
    scrollTrigger: {
      trigger: ".bgText--topLeft",
      scrub: true,
      invalidateOnRefresh: true
    }
  });
  topLeftTL.to(".bgText--topLeft", {
    yPercent: -70
  });

  const bottomRightTL = gsap.timeline({
    scrollTrigger: {
      trigger: ".bgText--bottomRight",
      scrub: true,
      invalidateOnRefresh: true
    }
  });
  bottomRightTL.to(".bgText--bottomRight", {yPercent: -70});

  const storyTL = gsap.timeline({
    scrollTrigger: {
      trigger: ".bgText--story",
      scrub: true,
      invalidateOnRefresh: true
    }
  });
  storyTL.to(".bgText--story", {yPercent: -60});

  const flavorTL = gsap.timeline({
    scrollTrigger: {
      trigger: ".bgText--flavor",
      scrub: true,
      invalidateOnRefresh: true
    }
  });
  flavorTL.to(".bgText--flavor", {yPercent: -60});

  setTimeout(() => {
    const handCraftedTL = gsap.timeline({
      scrollTrigger: {
        trigger: ".bgText--handCrafted",
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        invalidateOnRefresh: true
      }
    });
    handCraftedTL.to(".bgText--handCrafted", {
      yPercent: -100
    });
  }, 2000);

  (function() {
    const blurProperty = gsap.utils.checkPrefix("filter"),
          blurExp = /blur\((.+)?px\)/,
          getBlurMatch = target => (gsap.getProperty(target, blurProperty) || "").match(blurExp) || [];

    gsap.registerPlugin({
      name: "blur",
      get(target) {
        return +(getBlurMatch(target)[1]) || 0;
      },
      init(target, endValue) {
        let data = this,
            filter = gsap.getProperty(target, blurProperty),
            endBlur = "blur(" + endValue + "px)",
            match = getBlurMatch(target)[0],
            index;
        if (filter === "none") {
          filter = "";
        }
        if (match) {
          index = filter.indexOf(match);
          endValue = filter.substr(0, index) + endBlur + filter.substr(index + match.length);
        } else {
          endValue = filter + endBlur;
          filter += filter ? " blur(25px)" : "blur(25px)";
        }
        data.target = target;
        data.interp = gsap.utils.interpolate(filter, endValue);
      },
      render(progress, data) {
        data.target.style[blurProperty] = data.interp(progress);
      }
    });
  })();

  setTimeout(() => {
    const smokeyTL = gsap.timeline({
      scrollTrigger: {
        trigger: ".bgText--testimonials",
        start: "top 100%",
        end: "top 40%",
        scrub: true,
        invalidateOnRefresh: true
      }
    });
    smokeyTL.to(".bgText--testimonials", {
      yPercent: -40,
      // xPercent: -25,
      blur: 0,
    });
  }, 2000);
}
